export default {
	logged:null,
	tenant:null,
}


// WEBPACK FOOTER //
// ./src/store/cliente/state.js